import { render, staticRenderFns } from "./ConvocationLandingPage.vue?vue&type=template&id=29ff5ef3"
import script from "./ConvocationLandingPage.vue?vue&type=script&lang=js"
export * from "./ConvocationLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports